var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"arrow-link",class:{ 'arrow-link--big': _vm.big },attrs:{"href":_vm.href}},[_c('span',{staticClass:"arrow-link__arrow"},[_vm._v("→ ")]),_vm._v(" "),_c('span',{staticClass:"arrow-link__text"},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec35dd40","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArrowLink.vue
// module id = null
// module chunks = 